import React from 'react'
import InnerHtml from '@peracto/peracto-editor-ui/dist/InnerHtml'

const FAQsRenderer = ({
    state: { faqs = [], selectedFaqIndex = 0 },
    isEditMode,
    focused,
    onChange,
}) => {
    const inStorefront = !window?.location?.pathname.includes('/content/edit/')

    if (!faqs?.length) {
        return inStorefront ? null : (
            <p className="text-gray-400 text-center py-4">No FAQ items added yet.</p>
        )
    }

    return (
        <div data-testid="faqs">
            {faqs.map((item, index) => (
                <div
                    key={index}
                    data-testid={`faq__item-${index}`}
                    style={{
                        boxShadow:
                            selectedFaqIndex === index && focused && 'inset 0 0 0 3px yellow',
                    }}
                    {...(isEditMode && {
                        onClick: () => onChange({ selectedFaqIndex: index }),
                    })}
                >
                    <InnerHtml content={item.question} />
                    <InnerHtml content={item.answer} />
                </div>
            ))}
        </div>
    )
}

export default FAQsRenderer
